import React, { StatelessComponent } from 'react';
import b from 'b_';

import './researcher-page.stub.css';

import { BreadcrumbsStub } from '@components/breadcrumbs';
import PublicationItemStub from '@components/publication-item/publication-item.stub';
import Rect from '@components/rect';

const class_ = b.with('researcher-page-stub');

const PublicationPageStub: StatelessComponent = () => {
    return (
        <div className={class_()}>
            <BreadcrumbsStub />
            <div className={class_('header')}>
                <Rect className={class_('title')} height={40} type="black" />
                <Rect className={class_('image')} height={150} />
            </div>
            <Rect width={400} height={40} type="black" />
            <PublicationItemStub itemsCount={5} type="vertical" />
            <Rect width={200} height={48} />
        </div>
    );
};

export default PublicationPageStub;
